/**
 * Returns an index for selecting a "daily featured" resort
 * based on the number of days since the Unix epoch (1970-01-01).
 * The index rotates through the list of resorts, changing once per day (UTC).
 *
 * @param totalResorts - Total number of resorts in the list
 * @returns Index (0-based) of the resort to feature today
 */
const getDailyFeaturedResortIndex = (totalResorts: number): number => {
  if (totalResorts <= 0) return 0;

  const msPerDay = 1000 * 60 * 60 * 24;
  const now = new Date();
  const utcNow = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const daysSinceEpoch = Math.floor(utcNow / msPerDay);

  return daysSinceEpoch % totalResorts;
};

export default getDailyFeaturedResortIndex;
